var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleQuestion = function SvgCircleQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.4 12a8.4 8.4 0 1 0-16.8 0 8.4 8.4 0 0 0 16.8 0m-18 0a9.6 9.6 0 1 1 19.2 0 9.6 9.6 0 0 1-19.2 0m6.3-2.7c0-1.158.942-2.1 2.1-2.1h2.1c1.332 0 2.4 1.088 2.4 2.412 0 .9-.502 1.732-1.308 2.145l-1.392.705v.738h-1.2v-1.473l.327-.17 1.717-.877c.401-.202.656-.622.656-1.076 0-.667-.54-1.211-1.2-1.211h-2.1c-.498 0-.9.401-.9.9v.3H8.7v-.3zm2.4 5.1h1.8v1.8h-1.8z"
  })));
};
export default SvgCircleQuestion;